<ng-container *ngIf="state">
    <ng-container *ngFor="let element of elements; let i = index">
        <opn-offer-evaluation-method [element]="elements[i]" [state]="state"></opn-offer-evaluation-method>
    </ng-container>
    <div>
        <div class="rich-actions">
            <a href="javascript:;" *ngIf="auth.isAuthorized('57AA22AD-2B5F-4DD1-AB76-47D4DA48B772')"
              (click)="addOfferEvaluationMethodElement()">
              <i class="fa fa-plus mr-1"></i>{{ translationManager.getTranslation('Нови унос') }}</a>
        </div>
    </div>
</ng-container>

